import { render, staticRenderFns } from "./EntityView.vue?vue&type=template&id=4ef9928b&scoped=true"
import script from "./EntityView.vue?vue&type=script&lang=js"
export * from "./EntityView.vue?vue&type=script&lang=js"
import style0 from "./EntityView.vue?vue&type=style&index=0&id=4ef9928b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef9928b",
  null
  
)

export default component.exports